var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-map',{ref:"map",staticClass:"map-view",attrs:{"center":_vm.mapCenter,"bounds":_vm.mapBounds,"tileLayer":_vm.mapLayer},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),_vm._v(" "),_c('map-tools')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }